import React, { useState } from 'react';
import { BOOLEAN, CREATE_FIELD, DATA_TYPE, DECIMAL, ENTER_NAME, TEXT_FIELD, FIELD_NAME, FRACTION, INTEGER, MULTI_CHOICE, TEXT, FIELD, CALCULATED, FILTER, CALCULATED_TOOL_TIP, FILTER_TOOL_TIP, RANGE_FIELD } from '../ISRConstants';
import { XIcon } from 'assests/GmsIcons';
import ToggleButton from 'Components/Common/components/Inputs/ToggleButton';
import OverlayIcon from 'Components/GMS/Rules/Components/OverlayIcon';

type TFieldProps = {
    id: string;
    onClose: () => void;
    onFieldSubmit: (fieldName: string, fieldType: string, calculated: boolean, filter: boolean) => void;
}

const CreateFieldDialog = ({id, onClose, onFieldSubmit}: TFieldProps) => {
    const [fieldName, setFieldName] = useState("");
    const [fieldType, setFieldType] = useState("");
    const [calculated, setCalculated] = useState<boolean>(false);
    const [filter, setFilter] = useState<boolean>(false);

    const handleOnCreateClick = () => {
        onFieldSubmit(fieldName, fieldType, calculated, filter);
        setFieldName("");
        setCalculated(false);
        setFilter(false);
        //setFieldType("");
    };

    const handleFieldNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldName(event.target.value);
    };

    const handleFieldTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setFieldType(event.target.value === 'Select' ? '' : event.target.value);
    };

    const handleCalculatedChange = (value: boolean) => {
        setCalculated(value);
    };

    const handleFilterChange = (value: boolean) => {
        setFilter(value);
    };

    return (
        <div id={id} className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-[38%] tw-h-auto`}>
                <div className='tw-flex tw-justify-between tw-items-center'>
                    <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>{CREATE_FIELD}</h2>
                    <button className='tw-mr-2' onClick={onClose}><XIcon /></button>
                </div>
                <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />  
                <div className={`tw-flex tw-items-center tw-px-3  tw-my-3 `}>
                    <div className='tw-w-[72%] tw-pe-2 tw-pt-1'>
                        <label className={`tw-text-sm tw-block tw-ps-1`}>{FIELD_NAME}</label>
                        <div className="tw-relative">
                            <input id="create_isr" value={fieldName} type="text" onChange={handleFieldNameChange} placeholder={ENTER_NAME} className='className={`tw-w-auto tw-min-w-full tw-border tw-border-[#EBECF0] tw-text-sm tw-block tw-py-2 tw-px-3 tw-m-1 tw-bg-[#fff] tw-bg-clip-padding tw-text-[#6B778C] focus:tw-text-gray-700 tw-rounded-[4px] tw-flex-grow tw-font-normal tw-shadow-none`}' />
                        </div>
                    </div>
                    <div className='tw-w-[28%] tw-ms-4'>
                        <label className='tw-text-sm tw-block'>{DATA_TYPE}</label>
                        <select className="drop-down-dm" 
                            onChange={handleFieldTypeChange} value={fieldType}>
                            <option>
                                Select
                            </option>
                            {[TEXT_FIELD, INTEGER, DECIMAL, FRACTION,  BOOLEAN, MULTI_CHOICE, RANGE_FIELD].map((item, index) => {
                                return (
                                    <option value={item} key={item + index}>
                                        {item}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className='tw-flex tw-items-center tw-px-4'>
                    <div className='tw-w-[30%]'>
                        <div className='tw-flex tw-items-center tw-gap-1 tw-mb-1'>
                            <label className='tw-text-sm tw-text-[#747593] tw-block'>{CALCULATED}</label>
                            <OverlayIcon message={CALCULATED_TOOL_TIP} />    
                        </div>
                        <ToggleButton
                        name="Calculated" 
                        value={calculated} 
                        onChange = {(e) => handleCalculatedChange(e.target.checked)} />
                    </div>
                    <div className='tw-w-[30%] tw-pe-2'>
                        <div className='tw-flex tw-items-center tw-gap-1 tw-mb-1'>
                            <label className='tw-text-sm tw-text-[#747593] tw-block'>{FILTER}</label>
                            <OverlayIcon message={FILTER_TOOL_TIP} />    
                        </div>
                        <ToggleButton
                            name="Filter" 
                            value={filter} 
                            onChange = {(e) => handleFilterChange(e.target.checked)} />
                    </div>            
                </div>
                <div className={`tw-px-3 tw-my-4 tw-flex tw-gap-2 tw-justify-end`}>
                    <button onClick={onClose} className='samll-outline-btn'>Done</button>
                    <button disabled={!fieldName || !fieldType} onClick={handleOnCreateClick} className={`small-filled-btn`}>Create</button>
                </div>
            </div>
        </div>
    );
}

export default CreateFieldDialog; 